export const YELLOW = 'YELLOW';
export const RED = 'RED';
export const GREY = 'GREY';
export const LIGHT_GREY = 'LIGHT_GREY';
export const LIGHT_GREY_UNDERLINED = 'LIGHT_GREY_UNDERLINED';
export const GREEN = 'GREEN';
export const LIGHT_BLUE = 'LIGHT_BLUE';
export const DEFAULT = 'DEFAULT';
